/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.generator

import io.kvision.core.Component
import io.kvision.html.Div
import pl.finn.forms.model.Components
import pl.finn.forms.model.ComponentsGroup
import pl.finn.forms.model.DocumentTreeNode
import pl.finn.forms.model.MaterialComponents
import pl.finn.forms.utils.form.FormBuilder

class CatalogPanel(state: FormStructure, reference: FormBuilder<DocumentTreeNode>) {

  var elements: ArrayList<DocumentTreeNode?>? = null
  private var elementPos: Int = 0
  var isFormWithTabs: Boolean = checkIfIsFormWithTabs(state.model?.get("wzor")!!)
  private val formState = state
  private val formReference = reference
  private val matcher = ElementMatcher(formReference, isFormWithTabs)
  private val componentsGroup = ComponentsGroup(matcher, formReference)
  private val components = Components(matcher, formReference)
  private val materialComponent = MaterialComponents(formState, formReference)
  private var parentElement: DocumentTreeNode? = null
  private val headingDiv = Div(className = "float-right ml-md-100 mb-5 width-500")
  private val bodyDiv = Div(className = "mt-5")
  private val titleDiv = Div()

  suspend fun createForm(): Component {
    elements = formState.elements?.children
    parentElement = formState.elements
    formState.elements?.let { componentsGroup.createHeader(it) }?.let { bodyDiv.add(it) }
    elements?.let { walkTree(it) }
    return Div(className = "form-highlight") {
      add(headingDiv)
      add(titleDiv)
      add(bodyDiv)
      if (isFormWithTabs) {
        add(matcher.tabLevel)
        add(materialComponent.createNavigationButtons())
      }
    }
  }

  private suspend fun walkTree(node: ArrayList<DocumentTreeNode?>) {
    var startFrom = 0
    if (node.size == 1) {
      parentElement = node[0]
      node[0]?.children?.let { walkTree(it) }
    } else {
      while (startFrom < node.size) {
        if (elementPos < 10) {
          with(node[startFrom]) {
            if (node[startFrom]?.name?.matches("OpisDokumentu|DaneDokumentu") == true) {
              // Clean
            } else {
              when {
                this?.name?.contains("Urzad") == true && !this.metaModel?.choiceView.isNullOrEmpty() -> {
                  headingDiv.add(materialComponent.createAddresseeInput(this))
                  bodyDiv.add(components.createSimpleChoiceElement(this, parentElement))
                }
                this?.name?.contains("Urzad") == true -> headingDiv.add(materialComponent.createAddresseeInput(this))
                this?.name?.contains("Data") == true -> headingDiv.add(materialComponent.createDateTime(this))
                this?.typeName?.matches("Miejscowosc") == true -> headingDiv.add(materialComponent.createInputText(this))
                this?.name?.equals("annotation") == true -> titleDiv.add(materialComponent.createHeader(this))
                else -> matcher.matchElement(node[startFrom]!!, parentElement)?.let { bodyDiv.add(it) }
              }
            }
          }
        } else if (node[startFrom] != null) {
          matcher.matchElement(node[startFrom]!!, parentElement)?.let { bodyDiv.add(it) }
        }
        startFrom++
      }
    }
    elementPos++
  }

  private fun checkIfIsFormWithTabs(namespace: String): Boolean {
    return when (namespace) {
      "http://crd.gov.pl/wzor/2021/05/18/10639/" -> true
      "http://crd.gov.pl/wzor/2021/06/15/10693/" -> true
//      "http://crd.gov.pl/wzor/2020/10/01/9970/" -> true
      else -> false
    }
  }
}